import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import SmoothScroll from "@/components/SmoothScroll";
import CustomCursor from "@/components/CustomCursor";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Capabilities from "@/components/sections/Capabilities";
import Projects from "@/components/sections/Projects";
import Process from "@/components/sections/Process";
import Numbers from "@/components/sections/Numbers";
import Timeline from "@/components/sections/Timeline";
import Contact from "@/components/sections/Contact";
import WhatsAppButton from "@/components/WhatsAppButton";

function Home() {
  return (
    <div className="grain relative bg-navy-900">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Capabilities />
        <Projects />
        <Process />
        <Numbers />
        <Timeline />
        <Contact />
      </main>
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <SmoothScroll />
      <CustomCursor />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: { background: "#0A1128", border: "1px solid rgba(212,175,55,0.25)", color: "#F8F9FA" },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
